export default __webpack_public_path__ + "static/Floorplan_PH3AR-UL_v1-2c7ca0712281769e3b5c3f5cea5002a7.svg";